<template>
	<div class="ui-button" :class="{ inactive }">
		<div class="shadow" v-bg="'button-small.png'"></div>
		<div class="ui-button-content" v-bg="'button.png'" v-hammer:tap="active">
			<slot />
		</div>
	</div>
</template>

<script>
import Sounds from '@/js/sounds'

export default {
	name: 'ui-button',
	props: {
		inactive: { default: false }
	},
	methods: {
		active() {
			if (!this.inactive) Sounds.play('button')
		}
	}
}
</script>

<style lang="stylus" scoped>

.ui-button
	display inline-block
	color darken(#F5B474, 85%)
	font-size 4rem
	line-height 0.7em
	&:hover
		.shadow
			opacity 0.5
		.ui-button-content
			transform translate(1px, -2px)
	&:active
		.shadow
			opacity 0.5
		.ui-button-content
			transform translate(-2px, 4px)
	&.inactive
		opacity 0.5
		transform none
		background-color @background-color
		&:hover
			.shadow
				opacity 0.25
			.ui-button-content
				transform translate(-2px, 4px)
		&:active
			.shadow
				opacity 0.25
			.ui-button-content
				transform translate(-2px, 4px)
		.ui-button-content
			transform translate(-2px, 4px)
	.shadow
		absolute 0
		transform translate(-4px, 6px)
		background center center no-repeat
		background-size 100% 100%
		filter brightness(0)
		opacity 0.5
	.ui-button-content
		// width 100%
		// height 100%
		width 211px
		height 95px
		flex center center
		padding 24px 32px
		background center center no-repeat
		background-size 100% 100%

</style>
